'use strict';

module.exports = angular.module('superdostavka.commonServices', [])
.factory('posManager', ['$http', 'discountManager', '$rootScope', 'resourceCache', 'city', 'modal', 'metrics', 'userManager', '$timeout',
    function ($http, discountManager, $rootScope, resourceCache, city, modal, metrics, userManager, $timeout) {

    var posManager = {

        positions: {},
        removedPositions: [],
        sections: {},
        cart: {},
        isPickup: false,
        errorPromocode: null,
        loadPromocode: false,
        activeSection: null,
        positionsLoaded: false,
        singlePositionId: 0,
        cityId: null,
        promocode: null,
        additionPositions: [],

        init: function() {
            let p1 = this.getPositions();
            let p2 = this.getSections();

            return Promise.all([p1, p2]).then(() => {
                $rootScope.$broadcast('posManager.ready');
            })
        },
        getPositions: function() {
            var params = {};

            if (city && city.id !== undefined) {
                params.cityId = city.id;
            }

            this.cityId = params.cityId;

            return $http.get('/rapi/positions', {cache: resourceCache, params: params}).then(response => {
                this.positions = response.data.positions;

                for (let i in this.positions) {
                    if (this.positions[i].parent_id && this.positions['position_'+this.positions[i].parent_id]) {
                        this.positions['position_'+this.positions[i].parent_id].has_mods = true;
                    }

                    if (this.positions[i].fixed_sum_in_order && this.positions[i].fixed_sum_in_order > 0) {
                        this.positions[i].quantity = this.positions[i].fixed_sum_in_order;
                        this.positions[i].is_addition = true;
                    }
                }

                $rootScope.$broadcast('cartChanged');

                this.calculateCart();

                this.getAdditions(params.cityId)

                this.positionsLoaded = true;

                return this.positions;
            });
        },
        getMods: function(id) {
            var mods = [];
            var position = this.getPosition(id);

            for(var i in this.positions) {
                if (position.current_group_mod !== undefined
                    && this.positions[i].group_modification_id !== position.current_group_mod) {
                    continue;
                }

                if(this.positions[i].parent_id === id) {
                    mods.push(this.positions[i]);
                }
            }

            return mods;
        },
        getInfo: function(id) {
            return this.getActiveMod(id).info;
        },
        getActiveMod: function(id) {
            var pos = this.getPosition(id);

            if(!pos.has_mods)
                return pos;

            var mods = this.getMods(id);

            for(var i in mods)
            {
                if(i == pos.active_mod)
                    return mods[i];
            }

            return pos;
        },
        getSections: function() {
            return $http.get('/rapi/sections').then(response => {
                this.sections = response.data.sections;

                for (let i in this.sections) {
                    this.setSection(this.sections[i]);
                    break;
                }

                return this.sections;
            });
        },
        findSinglePositionId(sections, positions) {
            for (const sectionKey in sections) {
                if (sections[sectionKey].type === 1) {
                    for (const positionKey in positions) {
                        if (positions[positionKey].quantity && positions[positionKey].section_id === sections[sectionKey].id) {
                            return positions[positionKey].id;
                        }
                    }
                    break
                }
            }

            return null
        },
        setSinglePositionId(id) {
            this.singlePositionId = id;
        },
        setSection(section) {
            this.activeSection = section;
            this.activeSectionId = section.id;
        },
        getPosition: function(id) {
            var pos = this.positions['position_'+id];

            if(pos)
                return pos;

            return {};
        },
        // Сохраняем место промокода для старых шаблонов; метки удалённой аналитики не используем.
        addItem: function(id, quantity, modId, addition, _legacySource, _legacyPositionSource, promocode) {
            let item;

            if (modId) {
                item = this.getPosition(modId);
            } else {
                item = this.getActiveMod(id);
            }

            if (item.quantity + quantity < 0) {
                return;
            }

            item.is_addition = addition;

            if (!this.isLimit(item.id) || quantity < 0) {
                item.quantity = item.quantity * 1 + quantity;
            } else {
                return;
            }

            if (item.id == this.singlePositionId && item.quantity == 0) {
                this.singlePositionId = 0;
            }

            $http.get('/cartApi/addItem/'+item.id+'/'+quantity, {params: {promocode: promocode}}).success(function(response) {});

            if (this.cart.count == 0) {
                modal.hide('cart');
            }

            var sectionName = posManager.sections['id'+item.section_id];

            if (sectionName === undefined ) {
                sectionName = 'Неизвестно';
            } else {
                sectionName = sectionName.name;
            }

            metrics.addPosition(item, sectionName, quantity);
            metrics.metricsEvent('position_quantity_changed');

            $rootScope.$broadcast('cartChanged');
            this.calculateCart();
        },
        checkPromocode: function(promocode, showBubble = true) {

            if (showBubble) {
                this.loadPromocode = true;
            }

            if (promocode === '') {
                this.loadPromocode = false;
                return false;
            }

            $http.get('/rapi/checkPromocode/'+promocode).success(angular.bind(this, function(response) {
                if (response.success) {
                    if (!this.selectedPromocode()) {
                        this.loadPromocode = false;
                        this.addItem(response.position_id, 1, null, null, null, null, promocode);

                        if (showBubble) {
                            $rootScope.addedPos = this.getPosition(response.position_id);

                            modal.show('showAddedBubble');

                            $timeout(function() {
                                modal.hide('showAddedBubble');
                            }, 2000);
                        }
                    }
                }else {
                    this.loadPromocode = false;
                    this.errorPromocode = response.error;

                    $timeout(() => {
                        this.errorPromocode = null;
                    }, 4000);
                }
            }));
        },
        selectedPromocode: function() {
            for (let i in this.positions) {
                if (this.positions[i].quantity && this.positions[i].has_promocode) {
                    return this.positions[i];
                }
            }

            return false;
        },
        clearPromocode: function() {
            for (let i in this.positions) {
                if (this.positions[i].quantity && this.positions[i].has_promocode) {
                    this.addItem(this.positions[i].id, -1);
                }
            }

            this.promocode = null;
        },
        removePositionsIfPickup: function (pickup) {

            this.isPickup = pickup;

            if (pickup) {
                for (let i in this.positions) {
                    if (this.positions[i].hide_if_pickup) {
                        this.removedPositions[i] = this.positions[i];
                        this.positions[i].quantity = 0;
                    }
                }
            } else {
                for (let i in this.removedPositions) {
                    this.positions[i].quantity = this.removedPositions[i].fixed_sum_in_order;
                    delete this.removedPositions[i];
                }
            }
        },
        removeAfterPriceLimit: function (total) {

            let fixedPrice = 0;
            let refreshTotal = false;

            for (let i in this.positions) {
                if (this.positions[i].price_limit_to_remove
                    && this.positions[i].price_limit_to_remove > 0
                    && this.positions[i].quantity > 0) {
                    fixedPrice = fixedPrice + this.positions[i].price;
                }
            }

            total = total - fixedPrice;

            for (let i in this.positions) {
                if (this.positions[i].price_limit_to_remove && this.positions[i].price_limit_to_remove > 0) {

                    if (this.positions[i].price_limit_to_remove <= total ) {
                        this.positions[i].quantity = 0;
                    }else {
                        if (!this.isPickup || (this.isPickup && !this.positions[i].hide_if_pickup)) {
                            this.positions[i].quantity = this.positions[i].fixed_sum_in_order;
                        }
                    }

                    refreshTotal = true;
                }
            }

            return refreshTotal;
        },
        isLimit: function(id) {
            var item = this.positions['position_'+id];

            if(item && item.limit && item.quantity * 1 + 1 > item.limit)
                return true;

            return false;
        },
        getAdditions: function(cityId) {
            $http.get(
                '/rapi/addition_positions/client_additions',
                {params: {cityId: cityId}}
            ).success(res => {
                this.additionPositions = res.additions
            });
        },
        calculateCart: function() {
            var count = 0;
            var total = 0;
            var addition_count = 0;
            var addition_total = 0;

            var totalNoDiscount = 0;
            var positions = [];

            angular.forEach(this.positions, function(item, key) {
                if(item.quantity && !item.is_addition)
                {
                    count += item.quantity * 1;

                    var sum = item.quantity * item.price;
                    totalNoDiscount += sum;


                    total += sum;

                    // item.price_discount = price;
                    // total += price;
                }

                if (item.quantity && item.is_addition) {
                    addition_count += item.quantity * 1;
                    addition_total += (item.quantity * item.price);
                }
            });

            this.cart.count = count;
            this.cart.total = total;

            this.cart.addition_count = addition_count;
            this.cart.addition_total = addition_total;

            this.cart.totalNoDiscount = totalNoDiscount;
        },
    }
    // console.log('pos')
    return posManager;
}])
.factory('discountManager', ['$http', '$q', function ($http, $q) {
    var discountManager = {
        discounts: [],
        fixedDiscounts: [],
        _configLoaded: false,
        _loadPromise: null,

        loadConfig: function () {
            var deferred = $q.defer();

            if (this._configLoaded) {
                // уже загружено
                deferred.resolve();
                return deferred.promise;
            }

            if (this._loadPromise) {
                return this._loadPromise; // загрузка в процессе
            }

            this._loadPromise = deferred.promise;

            $http.get('/rapi/getDiscounts').success(angular.bind(this, function (response) {
                this.discounts = response.discounts;
                this.fixedDiscounts = response.fixedDiscounts;
                this._configLoaded = true;
                deferred.resolve();
            })).error(angular.bind(this, function () {
                this._loadPromise = null;
                deferred.reject();
            }));

            return this._loadPromise;
        },
    };

    // загружаем конфиг при инициализации, чтобы скидки были доступны сразу
    discountManager.loadConfig();

    return discountManager;
}])
.factory('streetsManager', ['$http', function ($http) {
    var streetsManager = {

        streets: [],

        loadStreets: function(cityId) {

            return $http.get('/rapi/getStreets', {params: {cityId: cityId}}).then(response => {
                this.streets = response.data.streets;
                return this.streets;

                // for(var i in this.streets)
                // {
                //     // this.streetsArr.push(this.streets[i].street);
                // }

            });
        },
        search: function (str) {
            let bestMatches = [];
            let matches = [];
            let limit = 0;

            streetsManager.streets.forEach(function(street) {
                let searchStr = str.toString().toLowerCase();
                let streetName = street.street.toLowerCase();

                if (limit < 20 && streetName.indexOf(searchStr) >= 0) {
                    if (streetName.match('^.*? ' + searchStr)) {
                        bestMatches.push(street);
                    }else {
                        matches.push(street);
                    }

                    limit++;
                }
            });

            return bestMatches.concat(matches);
        }
    }
    return streetsManager;
}])
.factory('orderManager', ['$http', '$timeout', 'posManager', 'discountManager', 'userManager', '$rootScope', 'metrics', 'city', function ($http, $timeout, posManager, discountManager, userManager, $rootScope, metrics, city) {
    var orderManager = {
        data: {
            address: {
                street: '',
                street_id: '',
                flat: '',
                building: ''
            },
            address_id: null,
            date: {type: 0},
            delivery_type: 0,
            pay_type: 0,
            discount: -1,
            confirm_type: 0,
            confirm_send: false,
            confirm_code: null,
            need_captcha: false,
            confirmed: false,
            contact_id: userManager.getMainContact().id,
            is_pickup: false
        },
        cart: {},
        password: '',
        manualStreet: '',
        firstOrder: false,
        email: '',
        emailSent: false,
        completed: false,
        showFullOrder: true,
        city: city,
        currentDeliveryZone: null,
        addressRequired: false,
        addressRequiredZone: false,
        deliveryPredictionConfig: {enabled: false},
        deliveryPrediction: {},
        deliveryPredictionTimer: null,
        activePredictionRequestId: null,
        // Состояние стоп-листа держим отдельно от errors: errors блокируют заказ всегда,
        // а 400 от проверки стоп-листа должен только показать alert и не мешать оформлению.
        positionStopListBlocked: false,
        positionStopListMessage: '',
        positionStopListRequestKey: null,
        positionStopListAlertKey: null,

        init: function() {
            userManager.getUser().then((res) => {
                let user = res.data.user;
                if (user !== undefined) {
                    let addresses = Object.keys(user.addresses);
                    let contacts = Object.keys(user.contacts);

                    if (addresses.length === 1) {
                        this.data.address_id = parseInt(addresses[0]);
                    }

                    if (contacts.length === 1) {
                        this.data.contact_id = parseInt(contacts[0]);
                    }
                }

                this.data.pay_type = this.getDefaultPayType();
                if (this.data.pay_type === null) {
                    setTimeout(() => {
                        this.data.pay_type = this.getDefaultPayType();
                        $rootScope.$digest();
                    }, 800);
                }
            });
        },
        setDeliveryPredictionConfig: function(config) {
            this.deliveryPredictionConfig = config || {enabled: false};
        },
        isDeliveryPredictionEnabled: function() {
            return !!(this.deliveryPredictionConfig && this.deliveryPredictionConfig.enabled);
        },
        clearDeliveryPrediction: function() {
            this.deliveryPrediction = {};
            this.activePredictionRequestId = null;
        },
        getPredictionPositions: function() {
            let positions = [];

            angular.forEach(posManager.positions, function(position) {
                if (!position.quantity) {
                    return;
                }

                positions.push({
                    id: position.id,
                    quantity: position.quantity,
                    price: position.price,
                    is_addition: !!position.is_addition,
                    is_promo: !!position.is_promo,
                });
            });

            return positions;
        },
        /**
         * Очищает результат проверки стоп-листа.
         *
         * resetAlert нужен для 400-ответов: они не блокируют заказ, но одинаковый alert
         * не должен повторяться при каждой автоматической перепроверке той же корзины.
         */
        clearPositionStopList: function(resetAlert = true) {
            this.positionStopListBlocked = false;
            this.positionStopListMessage = '';
            if (resetAlert) {
                this.positionStopListAlertKey = null;
            }
        },
        /**
         * Показывает сообщение стоп-листа без правки order.html.twig.
         *
         * requestKey входит в ключ alert, чтобы один и тот же запрет не всплывал
         * бесконечно при cartChanged/watch, но новая корзина или новый цех показали
         * пользователю актуальное сообщение.
         */
        showPositionStopListAlert: function(message, requestKey, force = false) {
            let alertKey = requestKey + '|' + message;

            // Автоматические перепроверки не должны показывать один и тот же alert бесконечно.
            if (!force && this.positionStopListAlertKey === alertKey) {
                return;
            }

            this.positionStopListAlertKey = alertKey;
            alert(message);
        },
        /**
         * Определяет актуальный цех и запускает проверку текущей корзины.
         *
         * Для самовывоза цех выбран пользователем в radio и лежит в data.workshop_id.
         * Для доставки цех приходит из зоны доставки и хранится в currentDeliveryZone.workshopId.
         */
        checkCurrentPositionStopList: function() {
            let workshopId = this.data.is_pickup
                ? this.data.workshop_id
                : this.currentDeliveryZone && this.currentDeliveryZone.workshopId;

            this.checkPositionStopList(workshopId);
        },
        /**
         * Предварительно проверяет корзину по стоп-листу конкретного цеха.
         *
         * Этот запрос ничего не меняет в заказе на сервере: он нужен только чтобы
         * предупредить клиента до /rapi/makeOrder и не создавать заведомо плохой заказ.
         */
        checkPositionStopList: function(workshopId) {
            workshopId = parseInt(workshopId);
            let positionIds = [];

            angular.forEach(posManager.positions, function(position) {
                // Проверяем именно позиции в корзине: бэкенд сам учтет родителей модификаций.
                if (position.quantity && position.id) {
                    positionIds.push(parseInt(position.id));
                }
            });

            // Сортировка делает requestKey стабильным: [2,1] и [1,2] считаются одной корзиной.
            positionIds = positionIds
                .filter(id => id > 0)
                .sort((a, b) => a - b);

            if (!workshopId || !positionIds.length) {
                // Неполный payload не отправляем: бэкенд вернет 400, а бизнес-смысла в проверке нет.
                this.positionStopListRequestKey = null;
                this.clearPositionStopList();
                return;
            }

            // Ключ защищает от гонок: старый ответ не должен перезатереть новую проверку.
            let requestKey = workshopId + ':' + positionIds.join(',');
            this.positionStopListRequestKey = requestKey;

            $http.post('/rapi/checkPositionStopList', {
                workshop_id: workshopId,
                position_ids: positionIds
            }).then(angular.bind(this, function(response) {
                if (this.positionStopListRequestKey !== requestKey) {
                    // Пользователь уже сменил корзину/цех, поэтому этот ответ устарел.
                    return;
                }

                if (response.data && response.data.stopped) {
                    // stopped=true блокирует только клиентскую отправку заказа; серверная проверка остается финальной защитой.
                    this.positionStopListBlocked = true;
                    this.positionStopListMessage = response.data.message || 'Позиции не доступны к заказу';
                    this.showPositionStopListAlert(this.positionStopListMessage, requestKey);
                    return;
                }

                this.clearPositionStopList();
            }), angular.bind(this, function(response) {
                if (this.positionStopListRequestKey !== requestKey) {
                    // Не показываем ошибку от старого запроса, если уже идет проверка актуальной корзины.
                    return;
                }

                this.clearPositionStopList(response.status !== 400);

                // 400 означает, что фронт не передал цех или позиции; заказ этим не блокируем.
                if (response.status === 400) {
                    this.showPositionStopListAlert('Не удалось передать цех или список позиций для проверки стоп-листа', requestKey);
                }
            }));
        },
        getActiveAddressForPrediction: function() {
            let address = null;

            if (this.data.address_id) {
                address = angular.copy(userManager.getAddressById(this.data.address_id) || {});
                if (address && !address.coordinates && this.currentDeliveryZone && this.currentDeliveryZone.addressCoordinates) {
                    address.coordinates = this.currentDeliveryZone.addressCoordinates;
                }
                return address || {};
            }

            address = angular.copy(this.data.address || {});
            if (this.currentDeliveryZone && this.currentDeliveryZone.addressCoordinates && !address.coordinates) {
                address.coordinates = this.currentDeliveryZone.addressCoordinates;
            }

            return address;
        },
        hasAddressForPrediction: function(address) {
            if (!address) {
                return false;
            }

            return !!(
                address.id
                || address.address_id
                || address.coordinates
                || address.street_id
                || address.kladr_id
                || ((address.street || '').toString().trim() !== '' && (address.building || '').toString().trim() !== '')
            );
        },
        normalizePredictionCoordinates: function(coordinates) {
            if (!coordinates) {
                return null;
            }

            if (angular.isString(coordinates)) {
                return coordinates.trim() !== '' ? coordinates.trim() : null;
            }

            if (angular.isArray(coordinates) && coordinates.length >= 2) {
                return [coordinates[0], coordinates[1]];
            }

            if (
                angular.isObject(coordinates)
                && coordinates.lat !== undefined
                && coordinates.lng !== undefined
            ) {
                return [coordinates.lat, coordinates.lng];
            }

            return null;
        },
        normalizePredictionNumber: function(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            let normalized = parseFloat(value);

            return isNaN(normalized) ? null : normalized;
        },
        buildPredictionAddressPayload: function(address) {
            if (!address) {
                return null;
            }

            let payload = {
                id: address.id || null,
                flat: address.flat || '',
                entrance: address.entrance || '',
                floor: address.floor || '',
                comment: address.comment || '',
                street_id: address.street_id || null,
                kladr_id: address.kladr_id || null,
                locality_id: address.locality_id || null,
                street: address.street || '',
                building: address.building || '',
                locality: address.locality || '',
                region: address.region || '',
                delivery_zone_id: address.delivery_zone_id || null,
                coordinates: this.normalizePredictionCoordinates(address.coordinates)
            };

            return this.hasAddressForPrediction(payload) ? payload : null;
        },
        buildDeliveryPredictionPayload: function() {
            let ts = Date.now();
            let requestId = 'site-dp-' + ts + '-' + Math.random().toString(16).slice(2);
            let orderExternalId = this.data.id ? String(this.data.id) : 'site-draft-' + ts + '-' + Math.random().toString(16).slice(2);
            let address = this.getActiveAddressForPrediction();
            let predictionAddress = this.buildPredictionAddressPayload(address);
            let totalNoDiscount = this.normalizePredictionNumber(this.cart.totalNoDiscount);
            if (totalNoDiscount === null) {
                totalNoDiscount = this.normalizePredictionNumber(this.data.sum_no_discount);
            }

            let total = this.normalizePredictionNumber(this.cart.total);
            if (total === null) {
                total = this.normalizePredictionNumber(this.data.sum);
            }

            let order = {
                id: this.data.id || null,
                user_id: this.data.user_id || null,
                address_id: this.data.address_id || null,
                city_id: (city && city.id) || this.data.city_id || null,
                workshop_id: this.data.workshop_id || null,
                delivery_zone_id: this.data.delivery_zone_id || null,
                is_pickup: Number(this.data.is_pickup) === 1 ? 1 : 0,
                delivery_type: parseInt(this.data.delivery_type || 0),
                source: this.data.source || 'site',
                source_type: this.data.source_type || 'web',
                confirm_type: this.data.confirm_type || 0,
                comment: this.data.comment || '',
                utc_timestamp: this.data.utc_timestamp || null,
                sum_no_discount: totalNoDiscount,
                sum: total,
                positions: this.getPredictionPositions(),
                giftPositions: []
            };

            if (city && city.id) {
                order.city_id = city.id;
            }

            if (!order.is_pickup && this.currentDeliveryZone) {
                if (this.currentDeliveryZone.zoneId) {
                    order.delivery_zone_id = this.currentDeliveryZone.zoneId;
                }
                if (this.currentDeliveryZone.workshopId) {
                    order.workshop_id = this.currentDeliveryZone.workshopId;
                }
            }

            if (predictionAddress) {
                order.address = predictionAddress;
            }

            return {
                requestId: requestId,
                orderExternalId: orderExternalId,
                order: order
            };
        },
        applyDeliveryPrediction: function(data) {
            if (data.apply_prediction === false || data.fallback_reason === 'unsupported_repeat') {
                return;
            }
            this.deliveryPrediction = {
                requestId: data.request_id || null,
                predictionSource: data.prediction_source || null,
                predictedTotalMinutes: data.predicted_total_minutes || null,
                predictedCookMinutes: data.predicted_cook_minutes || null,
                predictedDeliveryMinutes: data.predicted_delivery_minutes || null,
                missingFeatures: data.missing_features || []
            };

            if (angular.isNumber(data.predicted_cook_minutes)) {
                this.data.cook_time = Math.max(0, Math.round(data.predicted_cook_minutes));
            }

            if (angular.isNumber(data.predicted_delivery_minutes)) {
                this.data.making_time = Math.max(0, Math.round(data.predicted_delivery_minutes));
            }
        },
        getDeliveryPredictionContextKey: function() {
            return angular.toJson(this.buildDeliveryPredictionPayload().order);
        },
        getDeliveryPredictionWindow: function() {
            if (!this.deliveryPrediction || !angular.isNumber(this.deliveryPrediction.predictedTotalMinutes)) {
                return null;
            }

            let totalMinutes = Math.max(0, Math.round(this.deliveryPrediction.predictedTotalMinutes));
            let fromMinutes = Math.max(0, totalMinutes - 5);
            let toMinutes = Math.max(fromMinutes, totalMinutes + 10);

            return {
                from: fromMinutes,
                to: toMinutes
            };
        },
        getDeliveryPredictionWindowText: function() {
            let window = this.getDeliveryPredictionWindow();

            if (!window) {
                return '';
            }

            return window.from + '-' + window.to + ' мин.';
        },
        requestDeliveryPrediction: function() {
            if (!this.isDeliveryPredictionEnabled()) {
                return;
            }

            // Pickups are forecast as well (cook time only; delivery comes back as 0).
            if (this.data.delivery_type != 0) {
                this.clearDeliveryPrediction();
                return;
            }

            let payload = this.buildDeliveryPredictionPayload();
            let contextKey = angular.toJson(payload.order);
            this.activePredictionRequestId = payload.requestId;

            $http.post('/rapi/predictSiteDeliveryTime', payload).then(angular.bind(this, function(response) {
                if (this.activePredictionRequestId !== payload.requestId) {
                    return;
                }
                if (contextKey !== this.getDeliveryPredictionContextKey()) {
                    this.scheduleDeliveryPrediction(true);
                    return;
                }

                if (response.data) {
                    this.applyDeliveryPrediction(response.data);
                }
            }), angular.bind(this, function() {
                if (this.activePredictionRequestId !== payload.requestId) {
                    return;
                }
                if (contextKey !== this.getDeliveryPredictionContextKey()) {
                    this.scheduleDeliveryPrediction(true);
                    return;
                }

                this.clearDeliveryPrediction();
            }));
        },
        scheduleDeliveryPrediction: function(immediate = false) {
            // Invalidate the old response immediately, not only when the debounce fires.
            this.activePredictionRequestId = null;
            if (this.deliveryPredictionTimer) {
                $timeout.cancel(this.deliveryPredictionTimer);
                this.deliveryPredictionTimer = null;
            }

            if (!this.isDeliveryPredictionEnabled()) {
                return;
            }

            if (immediate) {
                this.requestDeliveryPrediction();
                return;
            }

            this.deliveryPredictionTimer = $timeout(angular.bind(this, function() {
                this.deliveryPredictionTimer = null;
                this.requestDeliveryPrediction();
            }), 500);
        },
        setCurrentDeliveryZone: function(zone) {
            if (zone) {
                this.currentDeliveryZone = zone;
                if (zone.zoneId) {
                    this.data.delivery_zone_id = zone.zoneId;
                }
                if (zone.workshopId) {
                    this.data.workshop_id = zone.workshopId;
                }
                if (zone.addressCoordinates) {
                    this.data.address.coordinates = zone.addressCoordinates;
                }
            } else {
                this.currentDeliveryZone = null;
                this.data.delivery_zone_id = null;
                this.data.workshop_id = null;
                // При сбросе зоны старый стоп-лист относится уже к другому цеху и не должен блокировать заказ.
                this.clearPositionStopList();
                this.clearDeliveryPrediction();
            }

            this.calculateTotal();
            this.scheduleDeliveryPrediction(true);
        },
        makeOrder: function(source = false) {
            this.saving = true;
            this.errors = [];

            if (this.positionStopListBlocked) {
                // Если последняя проверка нашла стоп-лист, не создаем заказ и повторно показываем причину.
                this.saving = false;
                this.showPositionStopListAlert(this.positionStopListMessage || 'Позиции не доступны к заказу', this.positionStopListRequestKey, true);
                return false;
            }

            // Add ReCaptcha validation token for order
            if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.getResponse === 'function') {
                this.data.grecaptcha_token = grecaptcha.getResponse()
            }

            if (city) {
                this.data.city_id = city.id;
            }

            if (source) {
                this.data.source = source;
            }

            if ((this.addressRequired || this.data.confirm_type === '1') && !this.data.address_id && !this.data.is_pickup) {
                if (!this.data.address.street && !this.data.address.street_id) {
                    this.errors.push('Введите улицу');
                }
                if (!this.data.address.building) {
                    this.errors.push('Введите здание');
                }
            }

            if (this.addressRequiredZone && !this.data.is_pickup) {
                const hasAddress = !!this.data.address_id || (
                    (this.data.address.street || this.data.address.street_id) && this.data.address.building
                );

                if (hasAddress && !this.currentDeliveryZone) {
                    this.errors.push('Адрес не попадает в зону доставки');
                }
            }

            if (this.data.confirm_type === '1') {
                if ((!this.data.contact || !this.data.contact.phone) && !this.data.contact_id) {
                    this.errors.push('Введите телефон');
                }

                if (this.data.is_pickup && !this.data.workshop_id) {
                    this.errors.push('Выберите адрес самовывоза');
                }

                if ((!this.data.contact || !this.data.contact.name) && !this.data.contact_id) {
                    this.errors.push('Введите имя');
                }
                if (!this.data.persons) {
                    this.errors.push('Введите кол-во персон');
                }
                if (!this.data.cash_paid && this.data.pay_type == 0) {
                    this.errors.push('Введите купюру');
                }
            }

            if (this.errors.length > 0) {
                this.saving = false;
                return false;
            }

            //TODO Разбить на элементы, чтобы всю эту логику в кучу не валить

            // Подтверждение по смс
            if (this.data.confirm_type === '1' && !this.data.confirmed && !userManager.user.username) {
                this.errors = [];

                if (!this.data.confirm_send) {
                    if (this.data.contact !== undefined && this.data.contact.phone !== '') {
                        let url = '/rapi/sendConfirmOrder?phone=' + this.data.contact.phone;
                        let config = { headers: { cp: document.getElementById('grecaptcha-input-2').value } };

                        $http.get(url, config).success(angular.bind(this, function(data) {
                            this.saving = false;
                            this.data.confirm_send = data.success;
                            this.data.need_captcha = !data.success;

                            if (this.data.need_captcha) {
                                this.errors = ['Введите капчу'];
                                if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.reset === 'function') {
                                    grecaptcha.reset(captchaWidget['recaptcha-2'])
                                }
                            }

                        }));

                        return true;
                    } else {

                        this.saving = false;

                        this.errors = ['Введите телефон'];

                        return false;
                    }
                } else {
                    $http.get('/rapi/confirmOrder/' + this.data.confirm_code).success(angular.bind(this, function(data) {

                        this.saving = false;

                        if (data.success) {
                            this.data.confirmed = true;
                            return this.makeOrder();
                        }

                        this.errors = ['Введен неверный код'];
                    }));

                    return true;
                }
            }

            if (this.data.date.day === undefined || this.data.date.day) {
                const datepicker = document.getElementById('datepicker');

                if (datepicker) {
                    this.data.date.day = datepicker.value;
                }
            }

            var promocodePosition = posManager.selectedPromocode();

            if (promocodePosition && promocodePosition.promocode !== undefined) {
                this.data.promocode = promocodePosition.promocode;
            }

            $http.post('/rapi/makeOrder', {order: this.data}).success(angular.bind(this, function(data) {

                this.saving = false;

                if(data.success && data.number)
                {
                    this.pushDataLayer(data.number);

                    if(data.redirect)
                    {
                        window.location.href = data.redirect;
                        return;
                    }

                    if (typeof ga !== 'undefined') {
                        ga('send', 'pageview', '/order_completed');
                    }
                    metrics.metricsEvent('order_completed');

                    this.completed  = true;
                    this.orderId  = data.number;
                    this.firstOrder = data.new_order;
                    this.password   = data.password;

                    if(this.firstOrder && typeof notAutoLogin == 'undefined')
                    {
                        userManager.loginForm._username = this.data.contact.phone;
                        userManager.loginForm._password = this.password;
                        userManager.login();
                    }

                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  // window.location.href = '/order/complete';
                } else
                {
                    if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.reset === 'function') {
                        grecaptcha.reset()
                    }

                    if (data.errors && Object.keys(data.errors).length > 0) {
                        this.errors = data.errors;
                    } else {
                        this.errors = ['Sorry, undefined error'];
                    }
                }

            })).error(angular.bind(this, function(data) {
              this.saving = false;
            }));
        },
        checkMinDeliveryPrice: function() {
            if (this.city.minDeliveryPrice !== '' && !this.data.is_pickup) {
                if (this.getTotal() < this.city.minDeliveryPrice) {
                    return false;
                }
            }

            return true;
        },
        pushDataLayer: function(id) {

            if (typeof dataLayer === 'undefined') {
                return false;
            }

            var googleItems = [];
            var yandexItems = [];

            for (var i in posManager.positions) {
                var pos = posManager.positions[i];

                if (pos.quantity == 0) {
                    continue;
                }

                googleItems.push({
                    'id' :      id,
                    'sku':      pos.id,
                    'name' :    pos.name,
                    'category': posManager.sections['id'+pos.section_id] !== undefined ? posManager.sections['id'+pos.section_id].name : '-',
                    'price':    pos.price,
                    'quantity': pos.quantity
                });

                yandexItems.push({
                    'id':       pos.id,
                    'name':     pos.name,
                    'price':    pos.price,
                    'category': posManager.sections['id'+pos.section_id] !== undefined ? posManager.sections['id'+pos.section_id].name : '-',
                    'quantity': pos.quantity,
                })
            }

            dataLayer.push({
                'transactionId':          id,
                'transactionAffiliation': '',
                'transactionTotal':       this.getTotal(),
                'transactionTax':         '0.00',
                'transactionShipping':    '0.00',
                'transactionProducts':    googleItems,
                'event':                  'trackTrans',

            });
            var goalId;

            if (typeof yandexGoalId !== 'undefined') {
                goalId = yandexGoalId;
            }

            dataLayer.push({
                "ecommerce": {
                    "purchase": {
                        "actionField": {
                            "id" : id,
                            "goal_id" : goalId,
                            "revenue": this.getTotal(),
                        },
                        "products": yandexItems
                    }
                }
            });
        },
        // applyDiscount === false: скидку самовывоза даёт оператор при предзаказе, сайт её не применяет.
        makePickupDiscount: function(applyDiscount) {
            if (this.data.is_pickup && applyDiscount !== false) {
                this.makeDiscount(1);
            } else {
                this.makeDiscount(-1);
            }

            posManager.removePositionsIfPickup(this.data.is_pickup);
            this.calculateTotal();
        },
        makeDiscount: function(discount) {
            this.discount = null;
            this.data.discount_id = null;

            if(discountManager.discounts[discount] && !discountManager.discounts[discount].disabled) {
                this.discount = discountManager.discounts[discount];
                this.data.discount_id = discount;
            }

            this.calculateTotal();
        },
        calculateDeliverySum: function(total) {
            let deliverySum = 0;
            if (this.currentDeliveryZone && this.data.is_pickup == false) {
                this.currentDeliveryZone.deliveryConfig.forEach((config) => {
                    if (parseFloat(total) >= parseFloat(config.sum)) {
                        deliverySum = parseFloat(config.price);
                    }
                })
            }

            return deliverySum;
        },
        calculateTotal: function(stopRecursion = false) {
            var count = 0;
            var total = 0;
            var totalNoDiscount = 0;
            var totalForBonuses = 0;

            var disc = 0;
            let promocodeDisc = 0;
            var effectiveDisc = 0;

            if(this.data.discount_id && this.data.discount_id != -1 && !this.discount)
                this.makeDiscount(this.data.discount_id);

            if(this.discount)
                disc = parseFloat(this.discount.value) || 0;

            // Ищем процент скидочного промокода заранее (берем первую подходящую позицию)
            angular.forEach(posManager.positions, function(item) {
                if (promocodeDisc > 0) {
                    return;
                }

                if (item.quantity && item.action_type === 1 && item.action_value > 0) {
                    promocodeDisc = parseFloat(item.action_value) || 0;
                }
            });

            effectiveDisc = (promocodeDisc > 0 && promocodeDisc >= disc) ? promocodeDisc : disc;

            // Применяем только одну процентную скидку к скидочным позициям
            angular.forEach(posManager.positions, function(item, key) {
                if(item.quantity)
                {
                    count += item.quantity * 1;

                    var sum = item.quantity * item.price;
                    totalNoDiscount += sum;

                    if(item.is_discount && effectiveDisc)
                        sum = sum - sum * effectiveDisc / 100;

                    if (item.is_discount)
                        totalForBonuses += sum;

                    // item.price_discount = item.price - item.price * disc / 100;
                    item.total = sum;
                    total += sum;
                }
            });

            if (!this.data.is_pickup) {
                this.errors = [];
                if (this.currentDeliveryZone && this.currentDeliveryZone.minSum && total < this.currentDeliveryZone.minSum) {
                    this.errors = ['Минимальная сумма заказа ' + this.currentDeliveryZone.minSum + ' руб.'];
                }

                let deliverySum = this.calculateDeliverySum(total);
                total += deliverySum;
                this.cart.deliverySum = deliverySum;
                this.cart.minSum = this.currentDeliveryZone ? this.currentDeliveryZone.minSum : 0;
            } else {
                this.cart.minSum = 0;
                this.cart.deliverySum = 0;
                this.errors = [];
            }

            this.cart.count = count;
            this.cart.total = total;
            this.cart.totalNoDiscount = totalNoDiscount;
            this.cart.totalForBonuses = totalForBonuses;

            if (posManager.removeAfterPriceLimit(total) && !stopRecursion) {
                this.calculateTotal(true);
                return;
            }

            this.scheduleDeliveryPrediction();
        },
        getTotal: function() {
            return this.cart.total;
        },
        getTotalNoDiscount: function() {
            return this.cart.totalNoDiscount;
        },
        getBonuses: function() {
            var percent = 5;

            if(userManager.user && userManager.user.bonus_percent)
                var percent = userManager.user.bonus_percent;

            return this.cart.totalForBonuses * percent / 100;
        },
        sendEmail: function(phone, password) {
            if (typeof(phone)==='undefined') phone = this.data.contact.phone;
            if (typeof(password)==='undefined') password = this.password;

            // password    = password || this.password;
            // phone       = phone || this.data.contact.phone;

            $http.post('/rapi/sendUserPasswordEmail', {email: this.email, password: this.password, phone: this.data.contact.phone}).success(angular.bind(this, function(data) {

                this.emailSaving = false;

                if(!data.errors) {
                    this.emailSent = true;
                    metrics.metricsEvent('registration_email_sent');
                } else {
                    this.emailErrors = data.errors;
                }

            })).error(angular.bind(this, function(data) {
                this.emailSaving = false;
            }));
        },
        setAddressId: function (addressPromise) {
            addressPromise.then((res) => {
                this.data.address_id = res.data.id;
            });

            return addressPromise;
        },
        setContactId: function (contactPromise) {
            contactPromise.then((res) => {
                this.data.contact_id = res.data.id;
            });

            return contactPromise;
        },
        getDefaultPayType() {
            let radios = document.getElementsByName('pay');

            for(let i = 0; i < radios.length; i++ ) {
                return radios[i].value;
            }

            return null;
        },
        isHourAvailableForExactlyOrder: function(hour, minutes) {
            const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD

            if (this.data.date.day !== today) {
                return true
            }
            let limitedTime = (new Date()).setMinutes(minutes)
            let neededTimeByHour = (new Date()).setHours(hour)

            return neededTimeByHour > limitedTime
        },
        isMinuteAvailableForExactlyOrder: function(minute, hour, minutesLimit) {
            const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD

            if (this.data.date.day !== today || !hour) {
                return true
            }
            let limitedTime = (new Date()).setMinutes(minutesLimit)
            let neededTime = (new Date())
            neededTime.setHours(hour)
            let neededTimestamp = neededTime.setMinutes(minute)

            return neededTimestamp > limitedTime
        }
    }

    $rootScope.$on('cartChanged', function () {
        orderManager.calculateTotal();
        // Любое изменение корзины может добавить/убрать позицию из стоп-листа текущего цеха.
        orderManager.checkCurrentPositionStopList();
    })

    $rootScope.$on('posManager.ready', function () {
        posManager.setSinglePositionId(posManager.findSinglePositionId(posManager.sections, posManager.positions))
    })

    return orderManager;
}])
.factory('modal', ['$animate', 'metrics', function ($animate, metrics) {
    var modal = {

        modals: {},

        isVisible: function(modal) {
            return this.isActive(modal);
        },
        isActive: function(modal) {
            if(!this.modals[modal])
                return false;

            return this.modals[modal].show;
        },
        toggle: function(modal, withOthers, hiddenLayout = false) {
            withOthers = typeof withOthers !== undefined ? withOthers : true;
            if (!this.modals[modal]) {
                return;
            }

            var show = this.modals[modal].show;

            if (withOthers) {
                this.hideAll();
            }

            if (this.modals[modal].el[0] !== undefined && document.body.clientWidth > 900) {
                let modalTitleHeader = this.modals[modal].el[0].getElementsByClassName('modalTitleHeader');
                let modalTitle = this.modals[modal].el[0].querySelectorAll('.modalTitle, .delivery__caption, .bonus-line-content-modal-top-info-caption, .promo-steps__caption');

                if (modalTitleHeader[0] !== undefined && modalTitle[0] !== undefined) {
                    modalTitleHeader[0].innerHTML = modalTitle[0].textContent;
                    modalTitle[0].remove();
                }
            }

            if (show) {
                this.modals[modal].show = false;

                if (hiddenLayout) {
                    document.body.classList.remove('hidden');
                }

            } else {
                metrics.modalShowEvent(modal);

                this.modals[modal].show = true;

                if (hiddenLayout) {
                    document.body.classList.add('hidden');
                }
            }

            this.animate(this.modals[modal]);
        },
        show: function(modal, reset = false) {
            // this.toggle(modal);
            if (!this.modals[modal]) {
                return;
            }
            this.modals[modal].show = true;
            this.animate(this.modals[modal]);
            // $animate.addClass(this.modals[modal].el, 'ng-hide')
            // console.log('hide', modal)
            // if (reset) {
            //     this.modals = [];
            // }

        },
        hide: function(modal, reset = false) {

            document.body.classList.remove('hidden');

            // this.toggle(modal);
            if (!this.modals[modal]) {
                return;
            }

            this.modals[modal].show = false;
            this.animate(this.modals[modal]);
            $animate.addClass(this.modals[modal].el, 'ng-hide')
            // console.log('hide', modal)
            // if (reset) {
            //     this.modals = [];
            // }

        },
        hideAll: function() {
            for(var i in this.modals)
            {
                this.modals[i].show = false;
                this.animate(this.modals[i]);
            }
        },
        setNew: function(id, element, addClass) {
            this.modals[id] = {el: element, addClass: addClass};
        },
        animate: function(modal) {
            // $animate[modal.show ? 'removeClass' : 'addClass'](modal.el, 'ng-hide');
            if (modal.show) {
                $animate.removeClass(modal.el, 'ng-hide')
            } else {
                $animate.addClass(modal.el, 'ng-hide')
            }
            // console.log(modal)
            // console.log('modal.show', modal.show)
            // console.log(modal.el)
        }
    }

    return modal;
}])
.factory('csrfManager', ['$http', function ($http) {
    var csrfManager = {
        tokens: {},
        getToken: function(type)
        {
            $http.get('/rapi/getCsrf/'+type).success(angular.bind(this, function(data) {
                this.tokens[type] = data.token;
            }));
        }
    }

    csrfManager.getToken('authenticate');

    return csrfManager;
}])
.factory('userManager', ['$http', 'csrfManager', 'metrics', function ($http, csrfManager, metrics) {
    var userManager = {

        user: {
            username: null,
            orderSumPercent: null,
            birthdaySend: false,
            sourceName: null,
            birthdaySeparated: null
        },
        collectEmailVars: {
            name: null,
            email: null,
            submited: false,
            errorExist: false,
            processing:false,
            success: false
        },
        birthdayRanges: null,
        loginForm: {recaptcha: null},
        restoreForm: {},
        userForm: {},
        newContact: {},
        newAddress: {},
        userPromise: null,
        isCaptchaNeeded: false,
        templateSmsSending: false,
        savingUserGroups: false,
        clientGroupsVariants: null,

        login: function() {
            if (!document.getElementById('recaptcha-wrapper').classList.contains('ng-hide') && !document.getElementById('grecaptcha-input').value) {
                return Promise.resolve(false);
            }

            this.loginErrors = null;
            this.loginProcessing = true;

            var promise = $http.post(
                '/login_check',
                {
                    '_username': this.loginForm._username,
                    '_password': this.loginForm._password,
                    '_csrf_token': csrfManager.tokens.authenticate,
                    'g-recaptcha-response': document.getElementById('grecaptcha-input').value
                },
                {headers : {'X-Requested-with' : 'XMLHttpRequest'}});



            promise.then((res) => {
                this.loginProcessing = false;
                document.getElementById('grecaptcha-input').value = '';
                if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.reset === 'function') {
                    grecaptcha.reset();
                }

                if (res.data.isCaptchaNeeded) {
                    // grecaptcha.reset('recaptcha');
                    this.isCaptchaNeeded = res.data.isCaptchaNeeded;
                }

                if (res.data.errors.length) {
                    csrfManager.getToken('authenticate');
                    this.loginErrors = true;
                    return false;
                } else {
                    this.getUser();
                    metrics.metricsEvent('logged_in');
                    return true;
                }


            }, (res) => {
                this.loginProcessing = false;
                this.loginErrors = true;
                document.getElementById('grecaptcha-input').value = '';
                if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.reset === 'function') {
                    grecaptcha.reset();
                }
                return false;
            });

            return promise;
        },
        restorePassword: function(success) {
            this.restoreError = false;
            this.restoreProcessing = true;

            $http.post('/rapi/reset/'+this.restoreForm.phone, {}, {headers : {'X-Requested-with' : 'XMLHttpRequest'}})
                .success(angular.bind(this, function(data) {
                    this.restoreProcessing = false;

                    if(data.success) {
                        this.restoreComplete = true;

                        if(success) {
                            success();
                        }
                    } else {
                        if (data.error) {
                            this.restoreError = data.error;
                        }
                    }
            }));
        },
        getUser: function(userId) {
            var url = '/rapi/getUser';
            if (userId) {
                url += '/'+userId;
            }

            this.userPromise = $http.get(url);

            this.userPromise.then(angular.bind(this, function(res) {
                this.init = true;

                if (res.data.user) {
                    this.user = res.data.user;

                    if (res.data.user.clientGroupsVariants) {
                        this.clientGroupsVariants = res.data.user.clientGroupsVariants
                    }
                }

                if (this.user.username) {
                    for (var i in this.user.contacts) {
                        if (this.user.contacts[i].phone == this.user.username) {
                            this.user.mainContact = this.user.contacts[i];
                        }
                    }
                }

                this.calculateCashbackPercent();

                if (this.user.birthday) {
                    this.user.birthdaySend = true;
                    let birthday = this.user.birthday.split('-')
                    this.user.birthdaySeparated = {
                        year: birthday[0],
                        month: birthday[1],
                        day: birthday[2]
                    }
                }

                this.user.loaded = true;
            }));

            return this.userPromise;
        },
        calculateCashbackPercent: function()
        {
            if (this.user && this.user.bonusLevels !== undefined) {

                var lastLevelPercent = 20;

                this.user.maxLevelMoney = (lastLevelPercent / 100 * this.user.maxLevelMoney) + this.user.maxLevelMoney;

                if (this.user.bonusLevels === undefined) {
                    return false;
                }

                this.user.bonusLevels.push({
                    'percent':lastLevelPercent,
                    'MoneyLimitFrom': this.user.maxLevelMoney,
                    'last': true
                });

                this.user.orderSumPercent = this.user.ordersSum > 0 ? this.user.ordersSum / this.user.maxLevelMoney * 100 : 0;

                if (this.user.bonusLevels && this.user.bonusLevels.length > 0) {

                    var obj = this;

                    this.user.bonusLevels.forEach(function(item, i, arr) {

                        var percent = 0;

                        if (arr[i + 1]) {
                            percent = (arr[i + 1].MoneyLimitFrom - item.MoneyLimitFrom) / obj.user.maxLevelMoney * 100;
                        }

                        obj.user.bonusLevels[i].percent = percent;

                    });
                }
            }
        },
        getMainContact: function() {
            if(!this.user || !this.user.contacts)
                return {};

            for (var i in this.user.contacts) {

                if(this.user.contacts[i].phone == this.user.phone)
                    return this.user.contacts[i]
            }

            for(var i in this.user.contacts)
            {
                return this.user.contacts[i];
            }

            return {};
        },
        saveAddress: function(address)
        {
            address.saving = true;

            let reqAddr = {
                address: {
                    street: address.street,
                    street_id: address.street_id,
                    locality: address.locality,
                    locality_id: address.locality_id,
                    kladr_id: address.kladr_id,
                    building: address.building,
                    building_short_name: address.building_short_name,
                    flat: address.flat,
                    entrance: address.entrance,
                    floor: address.floor,
                    comment: address.comment,
                    city_id: address.city_id,
                }
            };

            $http.post('/rapi/editAddress/' + address.id, reqAddr).success(angular.bind(address, function(data) {
              if(data.errors)
              {
                address.errors = data.errors;
              } else
              {
                address.errors = {};
                address.edit = false;
              }
              address.saving = false;
            })).error(angular.bind(address, function() {
             address.saving = false;
            }));
        },
        createAddress: function()
        {
            this.newAddress.saving = true;

            var promise = $http.post('/rapi/newAddress/'+this.user.id, {address: this.newAddress});

            promise.then(angular.bind(this, function(res) {
              this.newAddress.saving = false;

              if(res.data.errors)
              {
                this.newAddress.errors = res.data.errors;
                alert(res.data.errors[0]);
              } else
              {
                this.newAddress.id = res.data.id;

                if(this.user.addresses.length == 0)
                  this.user.addresses = {};

                this.user.addresses[res.data.id] = {
                  id: res.data.id,
                  locality: this.newAddress.locality,
                  street: this.newAddress.street,
                  street_id: this.newAddress.street_id,
                  building: this.newAddress.building,
                  building_short_name: this.newAddress.building_short_name,
                  flat: this.newAddress.flat,
                  entrance: this.newAddress.entrance,
                  floor: this.newAddress.floor,
                  comment: this.newAddress.comment,
                };
                this.newAddress = {};
              }
            }));

            return promise;
      },
      saveContact: function(contact, success)
      {
        contact.saving = true;

        $http.post('/rapi/editContact/'+contact.id, {contact: contact}).success(function(data) {
          if(data.errors)
          {
            contact.errors = data.errors;
          } else
          {
            contact.errors = {};
            contact.edit = false;

            if(success)
                success();
          }

          contact.saving = false;
        }).error(function() {
          contact.saving = false;
        });
      },
      createContact: function()
      {
        this.newContact.saving = true;

        var promise = $http.post('/rapi/newContact/'+this.user.id, {contact: this.newContact});

        promise.then(angular.bind(this, function(res) {
          this.newContact.saving = false;
          if(res.data.errors)
          {
            this.newContact.errors = res.data.errors;
          } else
          {
            this.user.contacts[res.data.id] = {
              id: res.data.id,
              name: this.newContact.name,
              phone: this.newContact.phone,
            };

            this.newContact = {};
          }

        }));

        return promise;
      },
      selectNewStreet: function($item)
      {
        userManager.newAddress.locality = $item.originalObject.locality;
        userManager.newAddress.street_id = $item.originalObject.id;
        userManager.newAddress.street = $item.originalObject.street;
        // console.log(obj);
          // obj.street_id = $item.originalObject.id;
      },
      getAddressById: function(id) {
        if (!this.user || !this.user.addresses) {
            return false;
        }
        return this.user.addresses[id];
      },
      setBirthday: function(userId = false, birthday = false) {
          userId = userId !== false ? userId : this.user.id;
          birthday = birthday !== false ? birthday : this.user.birthdaySeparated ? this.user.birthdaySeparated.year
              + '-' + this.user.birthdaySeparated.month
              + '-' + this.user.birthdaySeparated.day : this.user.birthday;
          if (birthday && !isNaN(Date.parse(birthday)) && birthday.match(/\d{4}-\d{2}-\d{2}/)) {
              return $http.get('/rapi/setBirthday/'+ userId + '/' + birthday, {}).success((data) => {
                  this.user.birthday = birthday;
                  this.user.birthdaySend = true;
                  alert('День рождения сохранен! Дата: ' + birthday);
              });
          }

          alert('Проверьте, что вы полностью указали дату рождения!');
      },
      collectEmail: function(form)
      {
          this.collectEmailVars.submited = true;

          if (form.$valid) {

              this.collectEmailVars.processing = true;

              $http.get('/rapi/collectEmail', {
                  params: {
                      'name': this.collectEmailVars.name,
                      'email': this.collectEmailVars.email
                  }
              })
              .success(function (data) {

                  userManager.collectEmailVars.processing = false;

                  if (data.errors.length) {
                      userManager.collectEmailVars.errorExist = true;
                  }else{
                      userManager.collectEmailVars.success = true;
                  }
              });
          }
      }
    }

    return userManager;
}])
// UI state machine legacy-сайта для MAX. Она не принимает телефон для MAX:
// backend получает identity только из подписанной contact card в webhook.
// Manager отвечает за экран, polling и завершение обычной Symfony-сессии сайта.
.factory('maxAuthManager', ['$http', '$interval', '$timeout', 'modal', 'userManager', 'metrics', function ($http, $interval, $timeout, modal, userManager, metrics) {
    var maxAuthManager = {
        // CSRF выдаётся отдельным запросом после создания устойчивой guest session.
        csrfToken: null,
        // Password сохраняется в той же модалке и раскрывается без потери телефона.
        passwordVisible: false,
        processing: false,
        // Не допускает параллельные status-запросы при медленном соединении.
        polling: false,
        status: 'idle',
        error: null,
        openUrl: null,
        qrUrl: null,
        expiresIn: 0,
        pollTimer: null,
        countdownTimer: null,
        // Каждый open/pause меняет поколение операции. Запоздавший ответ старого
        // HTTP-запроса увидит другой ID и не откроет уже закрытый MAX-экран.
        operationId: 0,

        // Показывает существующий password-login и переводит фокус на пароль.
        revealPassword: function() {
            this.passwordVisible = true;
            $timeout(function() {
                var passwordInput = document.getElementById('site-login-password');
                if (passwordInput) {
                    passwordInput.focus();
                }
            });
        },

        // Последовательно получает CSRF, а затем создаёт MAX attempt. Эти шаги
        // нельзя запускать параллельно: токен должен принадлежать текущей session.
        open: function() {
            if (this.processing) {
                return;
            }

            this.operationId += 1;
            var operationId = this.operationId;
            this.resetState();
            this.csrfToken = null;
            this.processing = true;
            this.status = 'loading';

            return $http.get('/rapi/site-auth/max/csrf', {
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then(angular.bind(this, function(response) {
                // Пользователь мог закрыть модалку, пока сеть возвращала CSRF.
                if (operationId !== this.operationId || this.status !== 'loading') {
                    return;
                }

                var token = response.data && response.data.token;
                if (typeof token !== 'string' || token.length === 0) {
                    this.fail(response.data && response.data.message);
                    return;
                }

                this.csrfToken = token;
                this.processing = false;

                return this.start();
            }), angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return;
                }

                this.processing = false;
                this.fail(response.data && response.data.message);
            }));
        },

        // Каждое открытие создаёт новый server attempt и полный TTL. Телефон и
        // attempt ID в body отсутствуют: связь хранится в PHP session cookie.
        start: function() {
            if (this.processing || !this.csrfToken) {
                return;
            }

            this.stopTimers();
            this.processing = true;
            this.status = 'loading';
            this.error = null;
            var operationId = this.operationId;

            return $http.post('/rapi/site-auth/max/start', {}, {headers: this.headers()})
                .then(angular.bind(this, function(response) {
                    if (operationId !== this.operationId) {
                        return;
                    }

                    this.processing = false;

                    if (response.data.status === 'authenticated') {
                        this.completeAuthentication();
                        return;
                    }

                    if (response.data.status !== 'pending') {
                        this.fail(response.data.message);
                        return;
                    }

                    this.status = 'pending';
                    this.openUrl = response.data.open_url;
                    // Cache-buster заставляет браузер запросить свежий session-bound
                    // SVG после restart, несмотря на одинаковый путь endpoint.
                    this.qrUrl = response.data.qr_url + '?v=' + Date.now();
                    this.expiresIn = parseInt(response.data.expires_in, 10) || 0;
                    this.startTimers();
                }), angular.bind(this, function(response) {
                    if (operationId !== this.operationId) {
                        return;
                    }

                    this.processing = false;
                    this.fail(response.data && response.data.message);
                }));
        },

        // Опрашивает только Redis status. Каждый poll не отправляет сообщение в
        // MAX и не вызывает внешний платный сервис.
        poll: function() {
            if (this.polling || this.status !== 'pending') {
                return;
            }

            this.polling = true;
            var operationId = this.operationId;
            $http.post('/rapi/site-auth/max/status', {}, {headers: this.headers()})
                .then(angular.bind(this, function(response) {
                    // Не применяем результат уже скрытого/перезапущенного flow.
                    if (operationId !== this.operationId) {
                        return;
                    }

                    this.polling = false;

                    if (response.data.status === 'authenticated') {
                        this.completeAuthentication();
                    } else if (response.data.status === 'expired') {
                        this.expire();
                    } else if (response.data.status === 'error') {
                        this.fail(response.data.message);
                    } else if (response.data.status === 'pending' && response.data.expires_in !== undefined) {
                        this.expiresIn = Math.max(0, parseInt(response.data.expires_in, 10) || 0);
                    }
                }), angular.bind(this, function(response) {
                    if (operationId !== this.operationId) {
                        return;
                    }

                    this.polling = false;

                    this.fail(response.data && response.data.message);
                }));
        },

        // Polling раз в 3 секунды не нагружает MAX API: status читает только Redis.
        // Отдельный секундный таймер обновляет только отображаемый countdown.
        startTimers: function() {
            this.pollTimer = $interval(angular.bind(this, this.poll), 3000);
            this.countdownTimer = $interval(angular.bind(this, function() {
                this.expiresIn = Math.max(0, this.expiresIn - 1);
                if (this.expiresIn === 0) {
                    this.expire();
                }
            }), 1000);
        },

        // Любой уход с MAX-экрана проходит здесь, чтобы не оставить Angular
        // interval и параллельный HTTP polling после закрытия модалки.
        stopTimers: function() {
            if (this.pollTimer) {
                $interval.cancel(this.pollTimer);
                this.pollTimer = null;
            }
            if (this.countdownTimer) {
                $interval.cancel(this.countdownTimer);
                this.countdownTimer = null;
            }
            this.polling = false;
        },

        // TTL закончился: ссылка больше не используется, пользователь может restart.
        expire: function() {
            this.stopTimers();
            this.processing = false;
            this.status = 'expired';
        },

        // Техническая причина с сервера намеренно заменяется единым сообщением.
        fail: function(message) {
            this.stopTimers();
            this.processing = false;
            this.status = 'error';
            this.error = message || 'Не удалось завершить вход через MAX. Повторите попытку или войдите по паролю.';
        },

        // Backend уже создал Symfony-сессию. Обновляем текущего пользователя
        // существующим способом сайта и только затем закрываем MAX-модалку.
        completeAuthentication: function() {
            this.stopTimers();
            this.processing = false;
            this.status = 'authenticated';

            userManager.getUser().finally(function() {
                metrics.metricsEvent('logged_in');
                modal.hide('maxLogin');
            });
        },

        // Закрытие MAX-экрана не отзывает QR на сервере. operationId не позволяет
        // позднему HTTP-ответу снова открыть или изменить уже скрытую модалку.
        pause: function() {
            this.operationId += 1;
            this.stopTimers();
            this.processing = false;
        },

        // Используется крестиком; отдельный метод делает намерение шаблона явным.
        close: function() {
            this.pause();
        },

        // Возвращает существующую login-модалку через общий modal.toggle.
        back: function() {
            this.pause();
            modal.toggle('login', true);
        },

        // После expiry/error заново получаем CSRF и новый QR с полным TTL.
        // Отдельный cancel для этого не требуется.
        restart: function() {
            return this.open();
        },

        // Сбрасывает отображаемое состояние; open отдельно получает свежий CSRF.
        resetState: function() {
            this.stopTimers();
            this.processing = false;
            this.status = 'idle';
            this.error = null;
            this.openUrl = null;
            this.qrUrl = null;
            this.expiresIn = 0;
        },

        // CSRF передаётся только заголовком; старый endpoint с константой 123
        // и параметры из DOM для этого flow не используются.
        headers: function() {
            return {
                'X-CSRF-Token': this.csrfToken,
                'X-Requested-with': 'XMLHttpRequest'
            };
        }
    };

    return maxAuthManager;
}])
// Два Unibell-сценария старого сайта используют один session-bound CSRF и
// одну reCAPTCHA. Телефон отправляется только в start; verify/status работают
// с попыткой из PHP-сессии и не принимают идентификаторы пользователя.
.factory('unibellAuthManager', ['$http', '$interval', 'modal', 'userManager', 'metrics', function ($http, $interval, modal, userManager, metrics) {
    var genericError = 'Не удалось завершить вход по звонку. Повторите попытку или войдите по паролю.';

    var unibellAuthManager = {
        csrfToken: null,
        captchaVisible: false,
        selectedMethod: null,
        processing: false,
        error: null,

        voiceStatus: 'idle',
        voiceCode: '',
        voiceExpiresIn: 0,
        retryIn: 0,
        attemptsLeft: 3,
        voiceTimer: null,

        callMeStatus: 'idle',
        callMePhone: '',
        callMeExpiresIn: 0,
        callMePollTimer: null,
        callMeCountdownTimer: null,
        polling: false,
        operationId: 0,

        // Первый клик только раскрывает CAPTCHA. После её решения повторный
        // клик отправляет start; backend всё равно повторно валидирует token.
        request: function(method) {
            if (this.processing || (method !== 'call' && method !== 'call_me')) {
                return;
            }

            this.selectedMethod = method;
            this.error = null;
            this.captchaVisible = true;

            var captcha = this.getCaptchaToken();
            if (!captcha) {
                return;
            }

            return this.start(method, captcha);
        },

        start: function(method, captcha) {
            this.processing = true;
            this.error = null;
            this.operationId += 1;
            var operationId = this.operationId;

            return $http.get('/rapi/site-auth/unibell/csrf', {
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then(angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return null;
                }

                this.csrfToken = response.data && response.data.token;
                if (!this.csrfToken) {
                    throw new Error('Missing CSRF token');
                }

                var path = method === 'call' ? 'call/start' : 'call-me/start';

                return $http.post('/rapi/site-auth/unibell/' + path, {
                    phone: userManager.loginForm._username || '',
                    recaptcha: captcha
                }, {headers: this.headers()});
            })).then(angular.bind(this, function(response) {
                if (!response || operationId !== this.operationId) {
                    return;
                }

                this.processing = false;
                this.resetCaptcha(false);

                if (!response.data || response.data.status !== 'pending') {
                    this.fail(response.data && response.data.message);
                    return;
                }

                if (method === 'call') {
                    this.beginVoice(response.data);
                } else {
                    this.beginCallMe(response.data);
                }
            }), angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return;
                }

                this.processing = false;
                this.resetCaptcha(true);
                this.fail(response && response.data && response.data.message);
            }));
        },

        beginVoice: function(data) {
            this.stopCallMeTimers();
            this.stopVoiceTimer();
            this.voiceStatus = 'pending';
            this.voiceCode = '';
            this.voiceExpiresIn = Math.max(0, parseInt(data.expires_in, 10) || 0);
            this.retryIn = Math.max(0, parseInt(data.retry_in, 10) || 0);
            this.attemptsLeft = 3;

            // Один локальный interval обслуживает оба счётчика и не создаёт HTTP.
            this.voiceTimer = $interval(angular.bind(this, function() {
                this.voiceExpiresIn = Math.max(0, this.voiceExpiresIn - 1);
                this.retryIn = Math.max(0, this.retryIn - 1);
                if (this.voiceExpiresIn === 0) {
                    this.voiceStatus = 'expired';
                    this.stopVoiceTimer();
                }
            }), 1000);
        },

        verifyVoice: function() {
            if (this.processing || !this.csrfToken
                || (this.voiceStatus !== 'pending' && this.voiceStatus !== 'invalid_code')) {
                return;
            }

            this.processing = true;
            this.error = null;
            var operationId = this.operationId;

            return $http.post('/rapi/site-auth/unibell/call/verify', {
                code: String(this.voiceCode || '').replace(/\D/g, '').slice(0, 4)
            }, {headers: this.headers()}).then(angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return;
                }

                this.processing = false;
                var status = response.data && response.data.status;
                if (status === 'authenticated') {
                    this.completeAuthentication('login');
                } else if (status === 'invalid_code') {
                    this.voiceStatus = 'invalid_code';
                    this.voiceCode = '';
                    this.attemptsLeft = parseInt(response.data.attempts_left, 10) || 0;
                    this.voiceExpiresIn = Math.max(0, parseInt(response.data.expires_in, 10) || 0);
                } else if (status === 'expired') {
                    this.voiceStatus = 'expired';
                    this.stopVoiceTimer();
                } else if (status === 'pending') {
                    this.voiceStatus = 'pending';
                } else {
                    this.fail(response.data && response.data.message);
                }
            }), angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return;
                }

                this.processing = false;
                this.fail(response && response.data && response.data.message);
            }));
        },

        beginCallMe: function(data) {
            this.stopVoiceTimer();
            this.voiceStatus = 'idle';
            this.stopCallMeTimers();
            this.callMeStatus = 'pending';
            this.callMePhone = data.call_me_phone || '';
            this.callMeExpiresIn = Math.max(0, parseInt(data.expires_in, 10) || 0);

            modal.toggle('unibellCallMe', true);
            this.callMePollTimer = $interval(angular.bind(this, this.pollCallMe), 3000);
            this.callMeCountdownTimer = $interval(angular.bind(this, function() {
                this.callMeExpiresIn = Math.max(0, this.callMeExpiresIn - 1);
                if (this.callMeExpiresIn === 0) {
                    this.expireCallMe();
                }
            }), 1000);
        },

        pollCallMe: function() {
            if (this.polling || this.callMeStatus !== 'pending' || !this.csrfToken) {
                return;
            }

            this.polling = true;
            var operationId = this.operationId;
            $http.post('/rapi/site-auth/unibell/call-me/status', {}, {
                headers: this.headers()
            }).then(angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return;
                }

                this.polling = false;
                var status = response.data && response.data.status;
                if (status === 'authenticated') {
                    this.completeAuthentication('unibellCallMe');
                } else if (status === 'expired') {
                    this.expireCallMe();
                } else if (status === 'error') {
                    this.failCallMe(response.data.message);
                } else if (status === 'pending' && response.data.expires_in !== undefined) {
                    this.callMeExpiresIn = Math.max(0, parseInt(response.data.expires_in, 10) || 0);
                }
            }), angular.bind(this, function(response) {
                if (operationId !== this.operationId) {
                    return;
                }

                this.polling = false;
                this.failCallMe(response && response.data && response.data.message);
            }));
        },

        expireCallMe: function() {
            this.stopCallMeTimers();
            this.callMeStatus = 'expired';
        },

        failCallMe: function(message) {
            this.stopCallMeTimers();
            this.callMeStatus = 'error';
            this.error = message || genericError;
        },

        fail: function(message) {
            this.error = message || genericError;
            if (this.selectedMethod === 'call') {
                this.voiceStatus = 'error';
                this.stopVoiceTimer();
            }
        },

        completeAuthentication: function(activeModal) {
            this.stopVoiceTimer();
            this.stopCallMeTimers();
            this.voiceStatus = 'authenticated';
            this.callMeStatus = 'authenticated';

            userManager.getUser().finally(function() {
                metrics.metricsEvent('logged_in');
                modal.hide(activeModal);
                modal.hide('login');
            });
        },

        stopVoiceTimer: function() {
            if (this.voiceTimer) {
                $interval.cancel(this.voiceTimer);
                this.voiceTimer = null;
            }
        },

        stopCallMeTimers: function() {
            if (this.callMePollTimer) {
                $interval.cancel(this.callMePollTimer);
                this.callMePollTimer = null;
            }
            if (this.callMeCountdownTimer) {
                $interval.cancel(this.callMeCountdownTimer);
                this.callMeCountdownTimer = null;
            }
            this.polling = false;
        },

        // Закрытие и Back не вызывают cancel endpoint: server-attempt остаётся
        // короткоживущей, а operationId игнорирует запоздавший polling response.
        pauseCallMe: function() {
            this.operationId += 1;
            this.stopCallMeTimers();
            this.processing = false;
            this.callMeStatus = 'idle';
        },

        closeCallMe: function() {
            this.pauseCallMe();
        },

        back: function() {
            this.pauseCallMe();
            modal.toggle('login', true);
        },

        // Используется при закрытии login или переходе к другому способу входа.
        pause: function() {
            this.operationId += 1;
            this.processing = false;
            this.stopVoiceTimer();
            this.stopCallMeTimers();
            this.voiceStatus = 'idle';
            this.callMeStatus = 'idle';
            this.selectedMethod = null;
            this.error = null;
            this.resetCaptcha(false);
        },

        // Перед обычным password-login останавливаем внешние flow, но не
        // сбрасываем CAPTCHA: этот же widget может требоваться /login_check.
        pauseForPassword: function() {
            this.operationId += 1;
            this.processing = false;
            this.stopVoiceTimer();
            this.stopCallMeTimers();
            this.voiceStatus = 'idle';
            this.callMeStatus = 'idle';
            this.captchaVisible = false;
            this.selectedMethod = null;
            this.error = null;
        },

        getCaptchaToken: function() {
            var input = document.getElementById('grecaptcha-input');

            return input ? input.value : '';
        },

        resetCaptcha: function(keepVisible) {
            var input = document.getElementById('grecaptcha-input');
            if (input) {
                input.value = '';
            }
            userManager.loginForm.recaptcha = null;
            if (typeof grecaptcha !== 'undefined' && grecaptcha && typeof grecaptcha.reset === 'function') {
                try {
                    grecaptcha.reset();
                } catch (e) {
                    // Widget мог ещё не успеть отрисоваться; token уже очищен.
                }
            }
            this.captchaVisible = !!keepVisible;
        },

        headers: function() {
            return {
                'X-CSRF-Token': this.csrfToken,
                'X-Requested-With': 'XMLHttpRequest'
            };
        }
    };

    return unibellAuthManager;
}])
.factory("resourceCache", ["$cacheFactory",
    function($cacheFactory) {
      return $cacheFactory("resourceCache");
    }
])
.factory('metrics', ['$http', function ($http) {
    var metrics = {

        modalEvents: {
            'cart': {
                'name': 'cart_opened',
                'category': 'cart',
                'action': 'open',
                'parameters': {'label': 'Cart opened'}
            },
            'giftPositions': {
                'name': 'gift_opened_main',
                'category': 'gift_list_main',
                'action': 'open',
                'parameters': {'label': 'Gift modal main'}
            },
            'giftPositionsOrder': {
                'name': 'gift_opened_order',
                'category': 'gift_choose_window',
                'action': 'open',
                'parameters': {'label': 'Gift modal order'}
            }
        },

        addPosition: function(position, sectionName, quantity) {
            this.addYandexPosition(position);
            this.addGooglePosition(position);
            this.metricsEvent('position_added');
        },

        addYandexPosition: function(position, sectionName, quantity) {
            if (typeof dataLayer === 'undefined') {
                return false;
            }

            dataLayer.push({
                "ecommerce": {
                    "add": {
                        "products": [
                            {
                                "id": position.id,
                                "name": position.name,
                                "price": position.price,
                                "category": sectionName,
                                "quantity": quantity
                            }
                        ]
                    }
                }
            });
        },

        addGooglePosition: function(position, sectionName, quantity) {
            if (typeof ga === 'undefined') {
                return;
            }

            ga('ec:addProduct', {
                'id': position.id,
                'name': position.name,
                'category': sectionName,
                'price': position.price,
                'quantity': 2
            });
        },

        metricsEvent: function(name) {
            this.googleEvent(name);
            this.reachYandexGoal(name);
            this.facebookPixel(name);
        },

        googleEvent: function (name) {
            if (typeof ga === 'undefined') {
                return;
            }

            ga('send', {
              hitType: 'event',
              eventLabel: name,
            });

            // ga('send', 'pageview', '/virtual/' + name);
        },
        facebookPixel: function (name) {
            if (typeof fbq === 'undefined') {
                return;
            }

            fbq('track', name)
        },

        reachYandexGoal: function(name) {
            let yandexCounter = this.getYandexCounter();

            if (yandexCounter && typeof yandexCounter.reachGoal == 'function') {
                yandexCounter.reachGoal(name);
            }
        },

        getYandexCounter: function() {
            if (!this.yandexCounter) {
                this.yandexCounter = false;

                let vars = Object.keys(window);

                for (let i in vars) {
                    // Дополнительный indexOf чтоб не было
                    // конфликта с кодом calltouch у которого
                    // тоже есть вхождение yaCounter но с нижним подеркиванием
                    if (vars[i].indexOf('yaCounter') != -1 && vars[i].indexOf('_yaCounter') == -1) {
                        this.yandexCounter = window[vars[i]];
                    }
                }
            }

            return this.yandexCounter;
        },

        modalShowEvent: function(modal) {
            if (!this.modalEvents[modal]) {
                return;
            }

            let modEv = this.modalEvents[modal];

            this.metricsEvent(modEv.name);
        }
    }

    return metrics;
}]);
